import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}

// Remove wholesale results unless wholesale customer per Jessa requested on 03/05/2026
// document.addEventListener("DOMContentLoaded", function () {

//   // Only run this script on the search page
//   if (!window.location.pathname.startsWith('/search')) {
//     return;
//   }

//   if (window.isWholesaleCustomer) return;

//   function removeWholesaleProducts() {

//     const productCards = document.querySelectorAll(
//       '.card, .product-card, .grid__item, .product-grid-item'
//     );

//     productCards.forEach(card => {

//       const titleEl = card.querySelector(
//         '.card__heading, .product-card__title, h3, h4, a'
//       );

//       if (!titleEl) return;

//       const title = titleEl.textContent.toLowerCase();

//       if (title.includes('wholesale')) {
//         const wrapper = card.closest('.grid__item, li, .predictive-search-results__card');
//           if (wrapper) {
//             wrapper.remove();
//           }
//       }

//     });

//   }

//   const observer = new MutationObserver(removeWholesaleProducts);

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   removeWholesaleProducts();

// });

// 3/7/2026 Jessa would also like to remove retail products from search result if current customer is logged in [change order not in scope]
// Remove products from search results depending on wholesale status. Confirmed working - retail search page results shows retail only when customer not logged in or not 
// tagged 'Wholesale Customer' and those customers who are logged in and tagged 'Wholesale Customer' see only wholesale results on search page. Also need to update predictive-search.js with similar logic.
document.addEventListener("DOMContentLoaded", function () {

  // Only run this script on the search page
  if (!window.location.pathname.startsWith('/search')) {
    return;
  }

  function filterSearchProducts() {

    const productCards = document.querySelectorAll(
      '.card, .product-card, .grid__item, .product-grid-item'
    );

    productCards.forEach(card => {

      const titleEl = card.querySelector(
        '.card__heading, .product-card__title, h3, h4, a'
      );

      if (!titleEl) return;

      const title = titleEl.textContent.toLowerCase();

      let shouldRemove = false;

      // If customer IS wholesale → remove retail products
      if (window.isWholesaleCustomer) {
        if (!title.includes('wholesale')) {
          shouldRemove = true;
        }
      }

      // If customer is NOT wholesale → remove wholesale products
      else {
        if (title.includes('wholesale')) {
          shouldRemove = true;
        }
      }

      if (shouldRemove) {
        const wrapper = card.closest('.grid__item, li, .predictive-search-results__card');
        if (wrapper) {
          wrapper.remove();
        }
      }

    });

  }

  const observer = new MutationObserver(filterSearchProducts);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  filterSearchProducts();

});